var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18.2061 9 18.4036 9.08295 18.5482 9.23026L23.1636 13.9323C23.4616 14.2359 23.4578 14.7244 23.155 15.0232C22.8523 15.3221 22.3652 15.3183 22.0672 15.0146L18.7692 11.6548V21.5265C18.7692 21.9526 18.4248 22.298 18 22.298C17.5752 22.298 17.2308 21.9526 17.2308 21.5265V11.6548L13.9328 15.0146C13.6348 15.3183 13.1477 15.3221 12.845 15.0232C12.5422 14.7244 12.5384 14.2359 12.8364 13.9323L17.4518 9.23026C17.5964 9.08295 17.7939 9 18 9ZM8.76923 20.7551C9.19407 20.7551 9.53846 21.1005 9.53846 21.5265V22.702C9.53846 24.2352 10.7552 25.4571 12.2308 25.4571H23.7692C25.2448 25.4571 26.4615 24.2352 26.4615 22.702V21.5265C26.4615 21.1005 26.8059 20.7551 27.2308 20.7551C27.6556 20.7551 28 21.1005 28 21.5265V22.702C28 25.0643 26.1173 27 23.7692 27H12.2308C9.88282 27 8 25.0643 8 22.702V21.5265C8 21.1005 8.3444 20.7551 8.76923 20.7551Z",
    fill: "#2E3A59"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDark);
export default __webpack_public_path__ + "static/media/uploadDark.1c4c42d8.svg";
export { ForwardRef as ReactComponent };